import React from "react";
import { Col } from "react-bootstrap";
import PropTypes from "prop-types";

type ColumnProps = {
  children?: React.ReactNode;
  className?: String;
  md?: number;
  xs?: number;
  style?: object;
};

/**
 * This component gives the bootstrap columns a padding: 0 8px style instead of the default 0 15px
 */
const Column: React.FC<ColumnProps> = function ({ children, className, md, ...props }) {
  return (
    <Col md={md} className={`column ${className || ""}`} {...props}>
      {children}
    </Col>
  );
};

Column.propTypes = {
  className: PropTypes.string,
  md: PropTypes.number,
  xs: PropTypes.number,
  style: PropTypes.instanceOf(Object),
};

Column.defaultProps = {
  className: "",
  children: null,
  md: undefined,
  xs: undefined,
  style: {},
};

export default Column;
